// Model.js
// -----------------------
// @module Case
define("NVT.MyOrganiserProfile.MyOrgProfile.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/MyOrgProfile/SuiteScript2/MyOrgProfile.Service.ss"
            ),
            true
        )
});
});
